import React from "react";
import { useSelector } from "react-redux";
import { Container, List, ListItem, ListItemIcon, ListItemText } from "@airbus/components-react";
import { FiberManualRecord } from "@airbus/icons/react";
import './TableOfContents.scss';
import {FEATURES, getFeatureToggleList} from "../../config/feature.toggles";

const handleClick = (event) => {
  const elId = event.currentTarget.attributes['data-link'].value;
  elId && document.getElementById(elId).scrollIntoView();
}

const EISM_LABEL = "Dashboards - Environmental Footprint";
/**
 *
 * @param {*} contents to fetch contents
 */
const renderContents = contents => {
  return contents.map((content) => (
    <ListItem key={content.name}>{content.label}</ListItem>
  ));
};
const renderSections = tocList => {
  // Dynamically wraps EISM sections in 'exclude-print' to hide them from PDF/HTML
  // print views per business requirements.
  // Note: Remove the CSS logic once the EISM feature flag is enabled.
  return tocList.map(section => (
    <ListItem key={section.name} data-link={section.name} onClick={handleClick} className={section.label === EISM_LABEL ? "exclude-print" : ""}>
      <ListItemIcon>
        <FiberManualRecord style={{ "height": "0.5em", "width": "0.5em" }} />
      </ListItemIcon>
      <ListItemText>
        {section.label}
      </ListItemText>
      <List>{renderContents(section.contents)}</List>
    </ListItem>
  ));
};
/**
 * Fetching & displaying contents of Table of Contents using template data
 */

const TableOfContents = () => {
  const templateList = useSelector(state => state);
  let tocList = templateList.reports.toc;
  const hiddenSections = templateList?.userData?.sectionHidden["Dashboards CO2"] || [];
  const dashboardSelectorData = templateList?.userData?.dashboardSelectorData || [];
  const isEFDashboardSelected = hiddenSections?.length > dashboardSelectorData?.length;
  const featureList = getFeatureToggleList();
  const isEISMSectionEnabled = featureList[FEATURES.EISM_SECTION];
  if (!isEISMSectionEnabled || isEFDashboardSelected) {
    tocList = tocList.filter(item => item.label !== EISM_LABEL);
  }
  return tocList && (
    <Container className='table-content-cls'>
      <div className='render-section-div'>
        <List>
          {renderSections(tocList)}
        </List>
      </div>
    </Container>
  );
};

export default TableOfContents;
